import React from 'react';
import PropTypes from 'prop-types';
import { dateToHtmlInputDate, dateToHtmlInputTime, getDateByDayId } from '../common';

const DateTimeEditor = props => {
  const date = new Date(props.input.value);
  const currentDate = dateToHtmlInputDate(date);
  const currentTime = dateToHtmlInputTime(date);
  const today = new Date().toISOString().split('T')[0];
  const future14 = getDateByDayId(9).toISOString().split('T')[0];
  const back6 = getDateByDayId(-5).toISOString().split('T')[0];

  let minMaxParams = props.twoWeeksOnly ? { min: today, max: future14 } : null;
  minMaxParams = props.sixDaysAgo ? { min: back6, max: future14 } : minMaxParams;

  const changeTime = newTime => {
    if (newTime) {
      props.input.onChange(`${currentDate} ${newTime}:00`);
    }
  };

  const changeDate = newDate => {
    if (newDate) {
      props.input.onChange(`${newDate} ${currentTime}:00`);
    }
  };

  return (
    <div>
      <div className="ScFormCol_50_left">
        <input
          name="time"
          type="date"
          placeholder=""
          value={currentDate}
          onChange={(evt) => { changeDate(evt.target.value); }}
          className="ScFormDate"
          disabled={props.dateDisable}
          required
          {...minMaxParams}
        />
      </div>

      {props.showTime && (
      <div className="ScFormCol_50_right">
        <input
          name="time"
          type="time"
          placeholder=""
          value={currentTime}
          onChange={(evt) => { changeTime(evt.target.value); }}
          className="ScFormTime"
          disabled={props.timeDisable}
          required
        />
      </div>
      )}
    </div>
  );
};

DateTimeEditor.propTypes = {
  dateDisable: PropTypes.bool,
  timeDisable: PropTypes.bool,
  showTime: PropTypes.bool,
  twoWeeksOnly: PropTypes.bool,
  sixDaysAgo: PropTypes.bool,
};

DateTimeEditor.defaultProps = {
  dateDisable: false,
  timeDisable: false,
  showTime: true,
  twoWeeksOnly: false,
  sixDaysAgo: false,
};

export default DateTimeEditor;



// WEBPACK FOOTER //
// ./src/components/DateTimeEditor.js